/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ProductListStoreAssignment
 */
export interface ProductListStoreAssignment {
    /**
     * 
     * @type {string}
     * @memberof ProductListStoreAssignment
     */
    storeId: string;
    /**
     * 
     * @type {Status}
     * @memberof ProductListStoreAssignment
     */
    status: Status;
    /**
     * 
     * @type {Date}
     * @memberof ProductListStoreAssignment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductListStoreAssignment
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ProductListStoreAssignment interface.
 */
// @ts-ignore
export function instanceOfProductListStoreAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "storeId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListStoreAssignmentFromJSON(json: any): ProductListStoreAssignment {
    return ProductListStoreAssignmentFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListStoreAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListStoreAssignment {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'storeId': json['store_id'],
        'status': StatusFromJSON(json['status']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

// @ts-ignore
export function ProductListStoreAssignmentToJSON(value?: ProductListStoreAssignment | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'store_id': value.storeId,
        'status': StatusToJSON(value.status),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

